import {MobileBox} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Background/Mobile/Contents/MobileBox';
import {EditorIcons} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/EditorIcons/EditorIcons';
import {useBackground} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Background/actions/useBackground';
import {EditorContainer} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Container/Mobile/EditorContainer';
import {BackgroundColorPicker} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/ColorPicker/BackgroundColorPicker';
import {useOverlay} from '~/common/OverlayAnimation/actions/useOverlay';
import './BackgroundEditorMobile.sass';

export const BackgroundEditorMobile = () => {
  const {backgroundIcons, onColorChange, onTextureChange, selectedBackground} = useBackground(true);
  const {onOverlayChange, overlayIcons, selectedOverlay} = useOverlay();

  return (
    <EditorContainer>
      <MobileBox title="Backgrounds" animated>
        <div className="background-editor__body">
          <EditorIcons
            icons={[
              {
                component: (
                  <BackgroundColorPicker onColorChange={onColorChange} key="bgcolorPickerKey" />
                ),
              },
            ].concat(backgroundIcons)}
            className="background-editor__body__icons"
            onClick={onTextureChange}
            selectedIcon={selectedBackground?.icon}
            highlight={false}
            height={50}
            width={50}
            noPadding
          />
        </div>
      </MobileBox>
      <MobileBox title="Effects">
        <EditorIcons
          icons={overlayIcons}
          selectedIcon={selectedOverlay}
          onClick={onOverlayChange}
          highlight={false}
          height={58}
          width={50}
          hideAnimatedIndicator
          className="editor-icons__effects--mobile"
          outline
        />
      </MobileBox>
    </EditorContainer>
  );
};
